// NGĂN TRƯỢT (10/10/2026, giao diện A2 — người dùng: "ít thao tác, mở popup / ngăn cho đỡ phải bấm Back nhiều").
// Việc NHANH mở ở ngăn bên phải, trang đang xem giữ nguyên bên dưới: Chi tiết lần chạy (#/runs/…), Dùng mẫu (#/kho-mau/:id), Chờ duyệt (#/cho-duyet).
// Sản phẩm KHÔNG ở ngăn (form dài có tải tệp / ảnh, quay về kịch bản) — để cả trang như cũ. Chỉ khi NGƯỜI BẤM liên kết / nút trong trang (hoặc trang gọi go()) — gõ địa chỉ, tải lại trang,
// mở từ menu trái vẫn là cả trang như cũ (liên kết chia sẻ không đổi).
// Địa chỉ vẫn đổi theo ngăn (#/runs/…) → Back của trình duyệt ĐÓNG ngăn và về đúng trang bên dưới mà không tải lại trang đó.
// Trong ngăn: liên kết / go() sang trang thường → THAY mục lịch sử của ngăn (location.replace) để Back sau đó về thẳng trang trước, không bấm thừa.
import { h } from "./dom";

const MAU_NGAN: { re: RegExp; ten: string }[] = [
  { re: /^\/runs\/.+/, ten: "Chi tiết lần chạy" },
  { re: /^\/kho-mau\/[^/?]+$/, ten: "Dùng mẫu" },
  { re: /^\/cho-duyet$/, ten: "Chờ duyệt" },
];

/** Đường dẫn (không gồm "?…") có mở được ở ngăn không; trả tên ngăn hoặc "". */
export function tenNgan(path: string): string {
  return MAU_NGAN.find((m) => m.re.test(path))?.ten ?? "";
}

function duongCuaHash(hash: string): string {
  const raw = hash.replace(/^#/, "");
  const qi = raw.indexOf("?");
  return qi >= 0 ? raw.slice(0, qi) : raw;
}

let yeuCau = false; // lần đổi địa chỉ kế tiếp do người bấm trong trang → mở ở ngăn
let veLai = false; // trang trong ngăn gọi go(<trang bên dưới>) (vd. xoá xong về danh sách) → Back rồi VẼ LẠI trang dưới cho số liệu mới
let goFn: (hash: string) => void = (hash) => { location.hash = hash; };
/** Trang (nhất là trang có thể nằm trong ngăn) chuyển trang qua đây thay vì gán location.hash — để ngăn xử lý lịch sử đúng. */
export function diToi(hash: string): void { goFn(hash); }
export function danhDauVeLai(): void { veLai = true; }
export function layVeLai(): boolean { const v = veLai; veLai = false; return v; }
let ngan: { duoi: string; than: HTMLElement; wrap: HTMLElement; cleanup?: () => void; gen: number } | null = null;
let genNgan = 0;

/** Trang (go()) muốn mở một đường dẫn: đánh dấu để dispatch mở ở ngăn nếu đường đó mở được ở ngăn. */
export function danhDauNeuNgan(hash: string): void {
  if (tenNgan(duongCuaHash(hash))) yeuCau = true;
}
/** dispatch hỏi: lần này có mở ở ngăn không (và xoá dấu). */
export function layYeuCauNgan(): boolean {
  const v = yeuCau;
  yeuCau = false;
  return v;
}
export function nganDangMo(): { duoi: string } | null {
  return ngan ? { duoi: ngan.duoi } : null;
}

/** Gỡ ngăn khỏi trang (không đụng lịch sử). */
export function goNgan(): void {
  if (!ngan) return;
  const n = ngan;
  ngan = null;
  try { n.cleanup?.(); } catch { /* trang tự dọn lỗi — bỏ qua */ }
  n.wrap.remove();
  document.body.classList.remove("co-ngan");
}

/** Người bấm × / nền / Esc: lùi lịch sử (Back) → hashchange về trang dưới → dispatch gỡ ngăn. */
export function dongNgan(): void {
  if (!ngan) return;
  // (13/10/2026, hạt khỉ 137 và 155) history.back() có thể ném người dùng RA KHỎI ứng dụng khi phía trước ngăn không còn trang app (trình duyệt bỏ qua mục lịch sử tạo ra không có thao tác
  // của người dùng, hoặc lịch sử đầu là trang trắng). Navigation API (Chromium) chỉ duyệt các mục CÙNG nguồn: back() không bao giờ rời ứng dụng; không lùi được / lỗi → thay mục ngăn bằng trang
  // bên dưới. Trình duyệt chưa có API đó: Back như cũ.
  const duoi = ngan.duoi;
  const veTrangDuoi = (): void => { if (ngan) { danhDauVeLai(); location.replace("#" + duoi); } };
  const nav = (window as unknown as { navigation?: { canGoBack?: boolean; back?: () => { finished: Promise<unknown> } } }).navigation;
  if (nav && typeof nav.back === "function") {
    if (nav.canGoBack === false) { veTrangDuoi(); return; }
    try { nav.back().finished.catch(veTrangDuoi); } catch { veTrangDuoi(); }
    return;
  }
  history.back();
}

/** Tạo (hoặc dùng lại) khung ngăn, trả phần thân để trang vẽ vào. */
export function moNgan(path: string, duoi: string): { than: HTMLElement; gen: number } {
  const ten = tenNgan(path) || "Chi tiết";
  if (!ngan) veLai = false; // ngăn mới: bỏ dấu "vẽ lại" còn sót của ngăn trước
  if (ngan) {
    try { ngan.cleanup?.(); } catch { /* bỏ qua */ }
    ngan.cleanup = undefined;
    ngan.than.replaceChildren();
    ngan.wrap.querySelector(".ngan-ten")!.textContent = ten;
    ngan.gen = ++genNgan;
    ngan.than.scrollTop = 0;
    return { than: ngan.than, gen: ngan.gen };
  }
  const than = h("div", { class: "ngan-than", "data-testid": "ngan-than" });
  const dong = h("button", { type: "button", class: "ngan-dong", "data-testid": "ngan-dong", "aria-label": "Đóng ngăn (về trang trước)", title: "Đóng (Esc hoặc nút Back của trình duyệt)", onclick: () => dongNgan() }, "×");
  const wrap = h("div", { class: "ngan-wrap", "data-testid": "ngan" },
    h("div", { class: "ngan-nen", "aria-hidden": "true", onclick: () => dongNgan() }),
    h("aside", { class: "ngan", role: "dialog", "aria-modal": "true", "aria-label": ten },
      h("div", { class: "ngan-dau" }, h("span", { class: "ngan-ten" }, ten), h("span", { class: "ngan-goi-y muted small" }, "Esc để đóng"), dong),
      than));
  document.body.append(wrap);
  document.body.classList.add("co-ngan");
  ngan = { duoi, than, wrap, gen: ++genNgan };
  setTimeout(() => { if (ngan?.wrap === wrap) dong.focus(); }, 0);
  return { than, gen: ngan.gen };
}
export function ganDonNgan(gen: number, c: (() => void) | void): boolean {
  if (!ngan || ngan.gen !== gen) { if (typeof c === "function") c(); return false; }
  if (typeof c === "function") ngan.cleanup = c;
  return true;
}

/** Bắt cú bấm liên kết (pha bắt sớm, trước khi trình duyệt đổi địa chỉ). Gọi một lần lúc khởi động. */
export function batNganTruot(goThay: (hash: string) => void): void {
  goFn = goThay;
  document.addEventListener("click", (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    const a = (e.target as Element | null)?.closest?.<HTMLAnchorElement>('a[href^="#/"]');
    if (!a || a.target) return;
    const path = duongCuaHash(a.getAttribute("href") ?? "");
    if (ngan && a.closest(".ngan")) {
      // trong ngăn: sang trang thường → thay mục lịch sử của ngăn; sang ngăn khác (lần chạy trước/sau…) → mở trong ngăn
      if (tenNgan(path)) { yeuCau = true; return; }
      e.preventDefault();
      goThay(a.getAttribute("href")!.replace(/^#/, ""));
      return;
    }
    if (a.closest("#nav")) return; // menu trái: luôn là cả trang
    if (tenNgan(path)) yeuCau = true;
  }, true);
}
